// @ts-nocheck
import PropTypes from 'prop-types';
import ContactCard from '../ContactCard/ContactCard';
import './ContactInformation.css';

const ContactInformation = ({ contacts = [] }) => {
  if (!contacts.length) {
    return null;
  }

  const contactList = contacts;

  return (
    <div className='pwa-contact-information'>
      <div className='pwa-contact-information__header'>
        <h2 className='pwa-contact-information__title'>Contact Information</h2>
        {/* <p className='pwa-contact-information__subtitle'>
          Your dedicated travel support team is here to help
        </p> */}
      </div>

      <div className='pwa-contact-information__cards'>
        {contactList.map((contact, index) => (
          <ContactCard
            key={contact.id || index}
            name={contact.name}
            description={contact.description}
            phone={contact.phone}
            whatsapp={contact.whatsapp}
            email={contact.email}
            type={contact.type || 'primary'}
          />
        ))}
      </div>

      {/* <div className='pwa-contact-information__footer'>
        <p className='pwa-contact-information__note'>
          💡 <strong>Tip:</strong> Save these contacts to your phone before
          traveling for quick access
        </p>
      </div> */}
    </div>
  );
};

ContactInformation.propTypes = {
  contacts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      phone: PropTypes.string,
      whatsapp: PropTypes.string,
      email: PropTypes.string,
      type: PropTypes.oneOf(['primary', 'emergency', 'secondary'])
    })
  )
};

export default ContactInformation;
